'use client'

import React from 'react'
import { MenuItem } from 'react-aria-components/Menu'

import { DropdownMenuLink, DropdownSeparator } from '@portal/taonga-ui'

import { css } from '@news/styled-system/css'
import { getLegalLinkHref, LEGAL_LINKS } from '@/entities/legal'
import { SelectCookiesButton } from '@/shared/lib/cookieyes'
import { useI18n } from '@/shared/providers'

export function LegalInfo() {
    const { i18n, lang } = useI18n()

    return (
        <React.Fragment>
            <DropdownSeparator />
            {LEGAL_LINKS.map(({ key, path, lang: linkLang }) => {
                if (linkLang && lang !== linkLang) {
                    return null
                }

                return (
                    <DropdownMenuLink
                        key={key}
                        href={getLegalLinkHref(lang, path)}
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {i18n[key]}
                    </DropdownMenuLink>
                )
            })}
            <SelectCookiesButton as={DropdownMenuLink} />
            <DropdownSeparator />
            <MenuItem
                isDisabled
                className={css({
                    paddingX: '2',
                    marginBottom: '1',
                    fontSize: '[12px]',
                })}
            >
                {i18n.PORTAL_COPYRIGHT_FULL}
            </MenuItem>
        </React.Fragment>
    )
}
